import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

export const badgeVariants = cva(
  "inline-flex items-center justify-center rounded-full border px-1.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-blue-600 text-primary-foreground",
        secondary: "border-transparent bg-secondary text-secondary-foreground",
        primary: "border-transparent bg-primary text-primary-foreground",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground",
        outline: "text-foreground",
        success: "border-transparent bg-green-500 text-white",
        warning: 'border-transparent bg-yellow-500 text-white',
        info: 'border-transparent bg-blue-600 text-white',
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

const Badge = ({ className, variant, ...props }: BadgeProps) => {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
};

export interface BadgeContainerProps extends BadgeProps {
  content: string;
  className?: string;
  children: React.ReactNode;
}

const BadgeContainer = ({
  children,
  content,
  className,
  ...props
}: BadgeContainerProps) => {
  return (
    <div className={className}>
      <div className="relative py-1.5 px-1.5 cursor-pointer">
        <Badge
          {...props}
          className="absolute right-0 top-0 text-2xs dark:text-white"
        >
          {content}
        </Badge>
        {children}
      </div>
    </div>
  );
};

Badge.Container = BadgeContainer;

export default Badge;
